import { render, staticRenderFns } from "./NotificationstatusbySubscriberDetails.html?vue&type=template&id=32349fd6&scoped=true&external"
import script from "./NotificationstatusbySubscriberDetails.ts?vue&type=script&lang=ts&external"
export * from "./NotificationstatusbySubscriberDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./NotificationstatusbySubscriberDetails.css?vue&type=style&index=0&id=32349fd6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32349fd6",
  null
  
)

export default component.exports